import { Controller } from "@hotwired/stimulus"

export default class NotificationController extends Controller {

    dismiss(): void {
        const notification = event.currentTarget.parentElement;
        notification.remove();
    }
}
